import { ChangeDetectionStrategy, Component } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { BasketApiMap } from 'src/business/basket';
import { CommonModule } from 'src/common/common.module';
import { origin } from 'src/utils/origin';
import { LineItemReturnModel } from 'src/business/openapi/models/LineItemReturnModel';
import { BasketResponseModel, BasketReturnModel } from 'src/business/openapi';
import { ImgHandleErrorDirective } from 'src/common/media/img.directive';
type ExtendedLineItemReturnModel = LineItemReturnModel & { srcset?: string }
type ExtendedBasketReturnModel = BasketReturnModel & { lines?: Array<ExtendedLineItemReturnModel> }
type ExtendedBasketResponseModel = BasketResponseModel & { basket?: ExtendedBasketReturnModel }
@Component({
  selector: 'app-ecommerce-basket-static',
  imports: [CommonModule, ImgHandleErrorDirective],
  templateUrl: './ecommerce-basket-static.component.html',
  styleUrl: './ecommerce-basket-static.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EcommerceBasketStaticComponent {
  basket = toSignal(BasketApiMap.basket$.pipe(map(b => {
    let clone = structuredClone(b) as ExtendedBasketResponseModel;
    if (clone?.basket?.lines != null)
      clone.basket.lines = clone.basket.lines.map(l => {
        let cloneL = structuredClone(l) as ExtendedLineItemReturnModel;
        if (!cloneL.imageUrl)
          return cloneL;

        let img = new URL(cloneL.imageUrl, origin());
        img.searchParams.set('bgcolor', 'transparent');
        img.searchParams.set('rsampler', 'mitchell');
        img.searchParams.set('format', 'webp');
        img.searchParams.set('rmode', 'pad');
        img.searchParams.set('width', '150');
        img.searchParams.set('height', '150');
        cloneL.imageUrl = img.href;
        img.searchParams.set('width', '300');
        img.searchParams.set('height', '300');
        cloneL.srcset = `${img.href} 2x`;
        return cloneL;
      })
    return clone;
  })));
}
